import React from 'react';

const PreviewSection = () => {
  return (
    <div className="preview-section">
      <div className="preview-title">Tentang XL AXIATA</div>
      <img 
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT59HZHPGL5ZJMHtWrcIdZs5oxJckWx32hwQw&s" 
        alt="XL AXIATA Logo" 
        className="preview-image" 
      />
      <p>XL Axiata adalah salah satu penyedia layanan telekomunikasi seluler terkemuka di Indonesia.</p>
      <a href="https://www.xl.co.id" target="_blank" rel="noopener noreferrer" className="preview-link">
        Kunjungi Situs Resmi XL AXIATA
      </a>
    </div>
  );
};

export default PreviewSection;
